import { render, staticRenderFns } from "./RevDetailView.vue?vue&type=template&id=49f507da&scoped=true"
import script from "./RevDetailView.vue?vue&type=script&lang=js"
export * from "./RevDetailView.vue?vue&type=script&lang=js"
import style0 from "./RevDetailView.vue?vue&type=style&index=0&id=49f507da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f507da",
  null
  
)

export default component.exports